var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-page-new',{on:{"init":_vm.handleInit,"submit":_vm.handleSubmit}},[_c('Details',{attrs:{"userData":_vm.userData,"userItems":_vm.userItems,"warehouseOptions":_vm.warehouseOptions}}),_c('Items',{attrs:{"userData":_vm.userData,"userItems":_vm.userItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }